/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'fail': {
    width: 128,
    height: 128,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M780.744 894.14L512.51 625.906 244.275 894.14 129.318 779.183 397.552 510.95 129.318 242.715l114.957-114.957L512.51 395.992l268.234-268.234L895.7 242.715 627.467 510.949 895.7 779.183 780.744 894.14z"/>'
  }
})
